function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  fill: "#434957",
  stroke: "#434957",
  strokeWidth: 0.4,
  d: "M1.482 5.157h5.334c.376 1.652 1.9 2.892 3.717 2.892 1.818 0 3.34-1.238 3.716-2.892h21.27c.452 0 .82-.357.82-.795a.808.808 0 0 0-.82-.794h-21.27c-.376-1.652-1.9-2.892-3.717-2.892-1.818 0-3.34 1.24-3.716 2.892H1.482a.809.809 0 0 0-.821.794c0 .44.366.795.82.795zm9.051-2.892c1.195 0 2.167.94 2.167 2.097s-.972 2.098-2.167 2.098c-1.194 0-2.166-.94-2.166-2.098 0-1.156.972-2.097 2.166-2.097z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 12.8)"
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  fill: "#434957",
  stroke: "#434957",
  strokeWidth: 0.4,
  d: "M30.864 3.995h4.656c.453 0 .821-.357.821-.795a.809.809 0 0 0-.82-.795h-4.657a.809.809 0 0 0-.82.795c0 .438.366.795.82.795zM1.231 3.995H23.8c.314 0 .57-.357.57-.795 0-.438-.256-.795-.57-.795H1.231c-.314 0-.57.357-.57.795 0 .438.255.795.57.795z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 27.478,
  cy: 3.147,
  className: "secondary-stroke",
  stroke: "#3D84FF",
  strokeWidth: 1.8,
  rx: 2.993,
  ry: 2.933
})), /*#__PURE__*/React.createElement("path", {
  className: "secondary-fill secondary-stroke",
  fill: "#434957",
  stroke: "#434957",
  strokeWidth: 0.4,
  d: "M1.482 28.432h11.31c.376 1.652 1.9 2.894 3.718 2.894s3.34-1.24 3.718-2.894H35.52c.453 0 .821-.356.821-.794a.809.809 0 0 0-.82-.795H20.227c-.376-1.652-1.9-2.892-3.718-2.892s-3.342 1.24-3.718 2.892H1.482a.809.809 0 0 0-.821.795c0 .438.366.794.82.794zm15.028-2.894c1.195 0 2.166.94 2.166 2.098 0 1.156-.971 2.097-2.166 2.097-1.195 0-2.167-.94-2.167-2.097s.972-2.098 2.167-2.098z"
}));

const SvgIcFeatureFlags = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 32,
    viewBox: "0 0 37 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcFeatureFlags, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-feature-flags.83ac18ce.svg";
export { ForwardRef as ReactComponent };